module.exports = __webpack_public_path__ + "static/media/02.3ce18c9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/japan-two/02.jpg
// module id = 456
// module chunks = 0